const routes = {
    createReconcile: 'reconcile/create',
    submitReconcile: 'reconcile/update',
    updateReconcile: 'reconcile/update/entry',
    getReconcileList: 'reconcile',
    getReconcileApproval: 'reconcile/approve',
    getReconcileDetail: 'reconcile',
    deleteReconcile: 'reconcile/deleteEntry',
    deleteReconcileStatement: 'reconcile/statementEntry',
    getVerifiedReports:"verified-reports",
    uploadReport:"verified-reports",
    deleteReport:"verified-reports"
  };
  
  export default routes